<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">
      <v-data-table :headers="headers" :items="communication_type_list" dense class="elevation-1 mytable"
        :search="search">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Communication Type</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row justify="center" dense>
            <v-col sm="3" md="1" cols="12">
            </v-col>
            <v-col sm="6" md="4" cols="12">

              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
              </v-text-field>
            </v-col>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small>Add Communication Type</v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">

                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12" v-if='editedIndex == -1'>
                          <v-autocomplete :items="communication_type_master_list"
                            v-model="addedItem.communication_type_master_list"
                            :hint="editedIndex==-1?'For example :: a,b,c':'Noneditable'"
                            label="Select Communication Type" :rules="[v => !!v || 'required']"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if='editedIndex != -1'>
                          <v-text-field v-model="editedItem.communicationType" persistent-hint
                            :disabled="editedIndex != -1" :rules="[v => !!v || 'required']"
                            :hint="editedIndex==-1?'For example :: a,b,c':'Noneditable'"
                            label="Communication Type"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="4" v-if='editedIndex != -1'>
                          <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                        </v-col>
                      </v-row>

                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>


        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2  v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2  v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
          <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
        </template>
        <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
   
  data: () => ({
      // extraBreadcrumbItems: [

      // { text: "Communication Type Master", disabled: true, href: "" },
      // ],
      // breadcrumbClass: "breadcrumb-style1",
      valid: false,
       overlay: false,
       communication_type_master_list:null,
     
      errorMsg:{
        communicationType:false
      },
      snackbar_msg: "",
      color: "",
      snackbar: false,
      search:'',
      dialog: false,
      headers: [
        {
          text: 'Communication Type',align: 'left',sortable: false,value: 'communicationType',
        },
        {
          text: 'Active',align: 'left',sortable: true,value: 'isactive',
        },
        { text: 'Actions', value: 'action', sortable: false },
      ],
      communication_type_list: [],
      editedIndex: -1,
      addedItem:{
         communication_type_master_list:''
      },
      editedItem: {
        id: '',
        communicationType: '',
        isactive:true  
      },
      defaultItem: {
        id: '',
        communicationType: '',
        isactive:true      
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Communication Type' : 'Edit Communication Type'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      overlay (val) {
        val = () => {
          this.overlay = false
        };
      },
    },

    // created () {
    //   this.initialize()
    // },
    mounted(){
      this.onLoad()
     },
    methods: {
    //   initialize () {
        
    //   },

      editItem (item) {
        this.editedIndex = this.communication_type_list.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      onLoad(){
               this.overlay=true;
         axios
      .post("/CommunicationType/communicationType")
      .then(res => {
        if (res.data.msg == "200") {
          //window.alert(res.data.msg)
         
          if(this.load = true){
          this.communication_type_master_list = res.data.communication_type_master_list;
          this.communication_type_list=res.data.communication_type_list;
          this.overlay=false;
          }
        } else {
          window.console.log(res.data.msg)
        }
      })
      .catch(error => {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        window.console.log(error);
      })
      .finally(()=>{ 
        'use strict';
        var overlay=false;
      });
      },
      // deleteItem (item) {
      //   const index = this.blood_group_master_list.indexOf(item)
      //   confirm('Are you sure you want to delete this item?') && this.blood_group_master_list.splice(index, 1)
      // },
      showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) 
        {
          if(this.isValidated())
         {
          axios
          .post("/CommunicationType/editCommunicationType", this.editedItem)
          .then(res => {
            if (res.data.msg == "200") {
              window.console.log(res.data.msg)
              Object.assign(this.communication_type_list[this.editedIndex], this.editedItem)
            }
               this.showSnackbar(
                  "#4caf50",
                  "Communication Type Updated Successfully..."
                ); // show snackbar on success
          })
          .catch(error => {
            window.console.log(error);
          });
            this.close()
         }
        } 
        else 
        {
           axios
          .post("/CommunicationType/saveCommunicationType", this.addedItem)
          .then(res => {
            if (res.data.status.code == "SUCCESS") {
             // window.alert(res.data.status.code)
              this.communication_type_list.push(this.addedItem)
              //console.log('added snackbar');
              this.showSnackbar("#4caf50", "Communication Type Added Successfully!!!"); // show snackbar on success 
              this.onLoad()           
            }
            else if(res.data.status.code == "NA"){
               // window.alert(res.data.status.code)
               // alert(res.data.status.message)
               this.showSnackbar("#b71c1c", "Communication Type Already Present!!!"); // show snackbar on error
            }
          })
          .catch(error => {
            window.console.log(error);
          });
          this.close()
        }
      }, //save()
    isValidated(){
      // alert('I am in isValidated()'+this.editedItem.name +"||" +this.editedItem.usertype.id +"||"+this.editedItem.roletype.id)
      if(this.editedItem.communicationType)
       { 
           return true; 
       }
      else{
            if(!this.editedItem.communicationType)
            {
              this.errorMsg.communicationType=true
            }
           
        return false;
      }  
     }, // .....end of isValidated()
    },
  }
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size{
  font-size: 20px;
}
.edit-avatar{
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover{
  background-color: #b0bec5;
}
.edit-v-icon{
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover{
  color: white;
}
.mytable /deep/ thead th {
      background: #0F2027;  /* fallback for old browsers */
      background: -webkit-linear-gradient(to right, #2C5364, #203A43, #0F2027);  /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2C5364, #203A43, #0F2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0F2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>